import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Compass } from "lucide-react";
import { api } from "@/api";
import { useLang } from "@/i18n";
import { PackageCard } from "@/components/PackageCard";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";

/** Consultazione degli itinerari e dei viaggi proposti (catalogo reale del
 *  gestionale). Il configuratore personalizzato vive su /itinerario/italia. */
export default function Itineraries() {
    const { lang, t } = useLang();
    const [packages, setPackages] = useState([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        api.get("/public/packages")
            .then((r) => setPackages(r.data || []))
            .catch(() => {})
            .finally(() => setLoaded(true));
    }, []);

    return (
        <div data-testid="itineraries-page" className="marble-bg min-h-screen pt-28 pb-24">
            <Seo lang={lang} title={`${t.nav.itineraries} — TOURVOYAGERS`} description={t.builder.signatureSub} />
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <Reveal>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-amber-500 font-semibold">TOURVOYAGERS</p>
                    <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-amber-50">{t.itinerariesPage.title}</h1>
                    <p className="mt-4 max-w-2xl text-sm sm:text-base text-stone-400 leading-relaxed">{t.itinerariesPage.sub}</p>
                </Reveal>

                <Reveal delay={0.1}>
                    <Link to="/itinerario" data-testid="itineraries-to-builder"
                        className="group mt-8 flex items-center gap-4 rounded-2xl border border-amber-500/25 bg-[#0b0b0c] p-5 transition-colors hover:border-amber-400/50">
                        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-amber-400/60 bg-amber-400/10 text-amber-300"><Compass size={20} /></span>
                        <span className="flex-1 min-w-0">
                            <span className="block font-display text-lg text-amber-50">{t.itinerariesPage.customTitle}</span>
                            <span className="block truncate text-xs text-stone-500">{t.itinerariesPage.customSub}</span>
                        </span>
                        <ArrowRight size={16} className="shrink-0 text-amber-400 transition-transform group-hover:translate-x-1" />
                    </Link>
                </Reveal>

                <div className="mt-12 grid gap-6 [grid-template-columns:repeat(auto-fill,minmax(300px,1fr))]" data-testid="itineraries-grid">
                    {packages.map((p, i) => <PackageCard key={p.id} pkg={p} index={i} />)}
                </div>
                {loaded && packages.length === 0 && (
                    <p className="mt-12 text-sm text-stone-500" data-testid="itineraries-empty">{t.itinerariesPage.empty}</p>
                )}
            </div>
        </div>
    );
}
